import React from 'react'
import { Card, Text, Button } from '@geist-ui/react'
import { useRouter } from 'next/router'
import { clearSessionStorage } from '../utils'

export default function ErrorDisplay({
  error,
  title,
  flowType,
  onRetry,
  onClearError,
  onClearProcessing,
}) {
  const router = useRouter()

  const handleRetry = () => {
    if (onClearError) onClearError(null)
    if (onClearProcessing) onClearProcessing(false)
    if (onRetry) {
      onRetry()
    } else {
      window.location.reload()
    }
  }

  const handleGoHome = () => {
    if (flowType === 'claim') {
      clearSessionStorage('pendingClaimEnrollment')
    } else if (flowType === 'link') {
      clearSessionStorage('pendingLinkTuple')
    }
    router.push('/')
  }

  const errorText = typeof error === 'string' ? error : JSON.stringify(error)

  return (
    <Card style={{ marginTop: '6rem', maxWidth: '600px', margin: '0 auto' }}>
      <Text h4>{title || 'Error'}</Text>
      <Text p>{errorText}</Text>
      <Button type="success" onClick={handleRetry}>
        Try Again
      </Button>
      <Button style={{ marginLeft: '10px' }} onClick={handleGoHome}>
        Go Home
      </Button>
    </Card>
  )
}
